export const NotificationType = {
  COMMUNICATION_PUBLISHED: 'COMMUNICATION_PUBLISHED',
  COMMUNICATION_UPDATED: 'COMMUNICATION_UPDATED',
  COMMUNICATION_URGENT: 'COMMUNICATION_URGENT',
  DEPARTMENT_ASSIGNED: 'DEPARTMENT_ASSIGNED',
  MENTION: 'MENTION',
  SYSTEM: 'SYSTEM',
} as const

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]

export interface Notification {
  id: string
  type: NotificationType
  title: string
  message: string
  isRead: boolean
  link?: string
  createdAt: string
}

export interface NotificationFilters {
  isRead?: boolean
  page?: number
  limit?: number
}

export interface NotificationListResponse {
  data: Notification[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
  unreadCount: number
  totalCount?: number
}
